<template>
  <div id="login2">
    
    <div id="content"><slot /></div> 
  </div>
</template>
<script>


export default {
  name: "loginLayout",
  
};

</script>
<style>

</style>

